/* eslint-disable */
export default async (data) => {
  try {
    if (navigator.share) {
      await navigator.share(data);
    } else {
      console.error('your browser not support navigator.share');
    }
  } catch (err) {
    console.error('share failed:', err);
  }
};
